<template>
  <div class="house-type">
    <div class="pic-wrap">
      <el-image :src="pictures" alt="" :preview-src-list="srcList" />
      <div class="shapan-tip" v-if="info.pcRid || info.rid" @click="shapanDetail(info)"></div>
    </div>
    <div class="info">
      <p>{{ info.name }}</p>
      <div class="area-orientation">
        <span>{{info.areaType}}{{info.area}}{{info.areaUnit}}｜朝向{{info.houseOrientation}}</span>
      </div>
      <div class="tags">
        <span v-for="item in tagsShow" :key="item">{{ item }}</span>
      </div>
      <div class="price">
        <div>{{info.totalPrice}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'house-type',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      srcList: [],
    }
  },
  computed: {
    tagsShow () {
      return this.info.points && this.info.points.length>2?this.info.points.slice(0,2):this.info.points
    },
    pictures () {
      if (!(this.info&&this.info.picture) && (this.info&&this.info.picture) !== null ) {
        return this.info && this.info.picture[0]
      }else {
        return this.info.previewPic
      }
    }
  },
  mounted () {
    this.info.picture.forEach(item => {
      this.srcList.push(item)
    })
    this.srcList.push(this.info.previewPic)
  },
  methods: {
    // 查看微沙盘
    shapanDetail (content) {
      const {rid, pcRid} = content
      const id = pcRid || rid
      axios.get(`https://xfj.coli688.com/super-gw/user-info/sand-box/shares/resources/${id}`)
      .then(res=>{
        const url = res.data.data.wechat_shares.jump_url || ''
        const newUrl = url.replace(/_saas/,"")
        this.goVrPage(newUrl, pcRid ? 'pc' : '')
      })
    },
    goVrPage (vrUrl, type) {
      setTimeout(() => {
        const routeData = this.$router.resolve({
          path: "/vrView",
          query: { vrUrl, pageFrom: 'back', type }
        })
        window.open(routeData.href, '_blank')
      },500)
    }
  }
}
</script>
<style lang="scss" scoped>
.house-type{
  position: relative;
  box-sizing: border-box;
  width: 287.5px;
  padding-bottom: 10px;
  border: 1px solid #E6E6E6;
  font-size: 0;
  .pic-wrap{
    margin: auto;
    width: 265px;
    overflow: hidden;
    position: relative;
    img{
      width: 100%
    }
  }
  .info{
    margin-left: 10px;
    p {
      @include font14(500, #333333);
      margin-top: 12px;
    }
    .area-orientation{
      @include font14(400, #9399A5);
      margin-top: 12px;
    }
    .tags{
      margin-top: 12px;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      height: 25px;
      span{
        display: inline-block;
        @include font12(400, #BDA26C);
        margin-right: 8px;
        border: 1px solid #BDA26C;
        padding: 3px;
      }
    }
    .price{
      margin-top: 8px;
      @include font14(500, #FA5741);
    }
  }
  .tags::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .shapan-tip{
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: 2px solid hsla(0,0%,100%,.5);
      color: #fff;
      &::before {
        content: "";
        display: inline-block;
        background: url(https://xfjoss.coli688.com/pc-images/sand-icon.png);
        background-size: cover;
        width: 40px;
        height: 40px;
        display: block;
      }
    }
}
::v-deep .el-image__inner--center {
  left: 0;
  transform: none;
}
</style>
